'use strict';

var util = require('./util');

module.exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}



//////////////////
// WEBPACK FOOTER
// ./~/ajv/lib/compile/schema_obj.js
// module id = ./node_modules/ajv/lib/compile/schema_obj.js
// module chunks = 54